import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { createExchangeFractions } from "./utils";
export const ExchangeFractionLabel = ({ targetExchangeAmounts, currentExchangeAmounts, variant, overrideStyle }) => {
    const exchangeFractions = createExchangeFractions({
        currentExchangeAmounts,
        targetExchangeAmounts,
    });
    return (_jsx(Typography, { sx: [
            { display: "flex", flexFlow: "row wrap", justifyContent: "space-around" },
            variant === "xs" ? { root: { fontSize: ".6rem", lineHeight: 1.1 } } : {},
        ], variant: variant === "lg" ? "subtitle1" : "caption", color: "inherit", children: exchangeFractions.map(({ numerator, denominator, label, id, type }) => (!!numerator || !!denominator) && (_jsxs(Box, { component: "span", sx: { flexBasis: "12.5%", textAlign: "center" }, children: [_jsx("span", { children: label }), " ", _jsx("br", {}), _jsxs(Box, { component: "span", sx: { color: numerator && numerator > denominator ? "error.main" : "inherit" }, children: [numerator, "/", denominator] })] }, id))) }));
};
//# sourceMappingURL=FractionLabel.js.map